import axios from 'axios/index';

export const UPDATE_WINDOW_DIMENSION = '[APP] UPDATE WINDOW DIMENSION';
export const SET_LOADING = '[APP] SET LOADING';
export const SET_LOADING_BESAR = '[APP] SET LOADING BESAR';
export const SET_DIALOG_SEKOLAH_BINAAN = '[APP] SET DIALOG SEKOLAH BINAAN';
export const SET_FEEDBACK = '[APP] SET FEEDBACK';
export const SET_HASIL_FEEDBACK = '[APP] SET HASIL FEEDBACK';
export const GET_JENIS_BADGE = '[APP] GET JENIS BADGE';
export const TOGGLE_BADGE_OPEN = '[APP] TOGGLE BADGE OPEN';
export const GET_DISPLAY_TOOLBAR = '[APP] GET DISPLAY TOOLBAR';
export const SET_DISPLAY_TOOLBAR = '[APP] SET DISPLAY TOOLBAR';
export const GET_JUDUL = '[APP] GET JUDUL';
export const SET_JUDUL = '[APP] SET JUDUL';
export const SET_KEPSEK_ISI_KUESIONER = '[APP] SET KEPSEK ISI KUESIONER';
export const SET_NOTIFIKASI = '[APP] SET NOTIFIKASI';
export const GET_NOTIFIKASI = '[APP] GET NOTIFIKASI';
export const GET_NOTIFIKASI_KECIL = '[APP] GET NOTIFIKASI KECIL';
export const SET_NOTIFIKASI_BACA = '[APP] SET NOTIFIKASI BACA';
export const GET_KEPALA_SEKOLAH = '[APP] GET KEPALA SEKOLAH';
export const LOGIN = '[APP] LOGIN';
export const REGISTRASI = '[APP] REGISTRASI';
export const BACKUP = '[APP] BACKUP';
export const GET_LOG_BACKUP = '[APP] GET LOG BACKUP';
export const GET_LOG_RESTORE = '[APP] GET LOG RESTORE';
export const RESTORE = '[APP] RESTORE';
export const REGISTRASI_DAPODIK = '[APP] REGISTRASI_DAPODIK';
export const REGISTRASI_DAPODIK_SEKOLAH = '[APP] REGISTRASI_DAPODIK_SEKOLAH';
export const GET_KOREG = '[APP] GET_KOREG';

export function updateWindowDimension()
{
    // console.log(window.innerHeight, window.innerWidth);
    
    return (dispatch) => {
        return dispatch ({
            type: UPDATE_WINDOW_DIMENSION,
            window_dimension: {
                height: window.innerHeight,
                width: window.innerWidth
            }
        })
    }
}

export function setLoading(loading)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_LOADING,
            loading: loading
        })
    }
}

export function setLoadingBesar(loading)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_LOADING_BESAR,
            loading_besar: loading
        })
    }
}

export function setDialogSekolahBinaan(toggle)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_DIALOG_SEKOLAH_BINAAN,
            dialog_sekolah_binaan: toggle
        })
    }
}

export function setDisplayToolbar(display_toolbar)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_DISPLAY_TOOLBAR,
          GET_JUDUL: SET_DISPLAY_TOOLBAR,
            display_toolbar: display_toolbar
        })
    }
}

export function getDisplayToolbar(display_toolbar)
{
    return (dispatch) => {
        return dispatch ({
            type: GET_DISPLAY_TOOLBAR,
            display_toolbar: display_toolbar
        })
    }
}

export function setHasilFeedback(loading)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_HASIL_FEEDBACK,
            hasil_simpan_feedback: loading
        })
    }
}

export function setFeedback(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/Feedback', {
        token: localStorage.getItem('jwt_token'),
        jenis_feedback_id: routeParams.jenis_feedback_id,
        judul: routeParams.judul,
        keterangan: routeParams.keterangan,
        saran: routeParams.saran,
        media_id: localStorage.getItem('tipe_app'),
        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SET_FEEDBACK,
                hasil_simpan_feedback: response.data,
                routeParams
            })
        });
}

export function getJenisBadge(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/JenisBadge/'+routeParams.jenis_badge_id, {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_JENIS_BADGE,
                payload: response.data,
                routeParams
            })
        });
}

export function toggleBadgeOpen(toggle_badge)
{
    console.log(toggle_badge);

    return (dispatch) => {
        return dispatch ({
            type: TOGGLE_BADGE_OPEN,
            toggle_badge: toggle_badge
        })
    }
}

export function getJudul(judul)
{
    return (dispatch) => {
        return dispatch ({
            type: GET_JUDUL,
            judul: judul
        })
    }
}

export function setJudul(judul)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_JUDUL,
            judul: judul
        })
    }
}

export function setKepsekIsiKuesioner(isi)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_KEPSEK_ISI_KUESIONER,
            kepsek_isi_kuesioner: isi
        })
    }
}

export function getNotifikasiKecil(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/Notifikasi', {
        token: localStorage.getItem('jwt_token'),
        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
        sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
        tahun: localStorage.getItem('tahun'),
        limit: routeParams.limit,
        start: routeParams.start 
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_NOTIFIKASI_KECIL,
                payload: response.data,
                routeParams
            })
        });
}

export function getNotifikasi(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/Notifikasi', {
        token: localStorage.getItem('jwt_token'),
        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
        sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
        tahun: localStorage.getItem('tahun'),
        limit: routeParams.limit,
        start: routeParams.start 
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_NOTIFIKASI,
                payload: response.data,
                routeParams
            })
        });
}

export function setNotifikasi(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/catatNotifikasi', {
        token: localStorage.getItem('jwt_token'),
        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
        sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
        keterangan: routeParams.keterangan,
        tautan: routeParams.tautan,
        tahun: localStorage.getItem('tahun'),
        tujuan_notifikasi_id: routeParams.tujuan_notifikasi_id,
        jenis_notifikasi_id: routeParams.jenis_notifikasi_id,
    });

    // 'jenis_notifikasi_id' => $request->input('jenis_notifikasi_id'),
    // 'sekolah_id' => $request->input('sekolah_id'),
    // 'pengguna_id' => $request->input('pengguna_id'),
    // 'keterangan' => $request->input('keterangan'),
    // 'status' => 1,
    // 'create_date' => date('Y-m-d H:i:s'),
    // 'last_update' => date('Y-m-d H:i:s'),
    // 'soft_delete' => 0,
    // 'updater_id' => $request->input('pengguna_id'),
    // 'last_sync' => date('Y-m-d H:i:s'),
    // 'tautan' => $request->input('tautan'),
    // 'tahun' => $request->input('tahun'),
    // 'tujuan_notifikasi_id' => $request->input('tujuan_notifikasi_id')

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SET_NOTIFIKASI,
                hasil_notifikasi: response.data,
                routeParams
            })
        });
}


export function setNotifikasiBaca(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/setNotifikasiBaca', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SET_NOTIFIKASI_BACA,
                payload: response.data,
                routeParams
            })
        });
}


export function getKepalaSekolah(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/getKepalaSekolah', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_KEPALA_SEKOLAH,
                payload: response.data,
                routeParams
            })
        });
}


export function login(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/login', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : LOGIN,
                payload: response.data,
                routeParams
            })
        });
}

export function registrasi(routeParams)
{
    const request = axios.get('http://localhost:1747/prefill/push_prefill.php?callback=callbacksync&act=registrasi&kode_registrasi='+routeParams.kode_registrasi+'&username='+routeParams.email+'&password='+routeParams.password);

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : REGISTRASI,
                payload: response.data,
                routeParams
            })
        });
}


export function backup(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/backup', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : BACKUP,
                payload: response.data,
                routeParams
            })
        });
}

export function getLogBackup(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/logBackup', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_LOG_BACKUP,
                payload: response.data,
                routeParams
            })
        });
}

export function getLogRestore(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/logRestore', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_LOG_RESTORE,
                payload: response.data,
                routeParams
            })
        });
}

export function restore(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/restore', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : RESTORE,
                payload: response.data,
                routeParams
            })
        });
}

export function RegistrasiDapodik(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/RegistrasiDapodik', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : REGISTRASI_DAPODIK,
                payload: response.data,
                routeParams
            })
        });
}

export function RegistrasiDapodikSekolah(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/RegistrasiDapodikSekolah', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : REGISTRASI_DAPODIK_SEKOLAH,
                payload: response.data,
                routeParams
            })
        });
}

export function getKoregDapodik(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getKoregDapodik', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_KOREG,
                payload: response.data,
                routeParams
            })
        });
}


// WEBPACK FOOTER //
// ./src/store/actions/App.actions.js